import clsx from 'clsx'
// import SVG from './Loading_spinner.svg?react'
import SVG from './spinner.svg?react'
import $anim from '@tandem/ui/anim.css'
import $ from './styles.css'

export default function Spinner(props: { class?: string }) {
    return <span class={props.class} style={{ display: 'inline-flex' }}><SVG class={clsx($anim.rotate, $.spinner)} /></span>
}